//import './index.css';

import App from './components/app/App';
import React from 'react';

const Settings = () => <App />;

export default {
  routeProps: {
    path: '/settings',
    component: Settings,
  },
  name: 'Settings',
  label: 'Settings',
  iconClassName: 'icon-cog',
  active: true,
  accessGroup: '',
};
